<div class="container-fluid footer-container">
  <div class="row justify-content-center">
    <p>&reg; Copyright All right reserved Edit Art 2020 Cluj-Napoca</p>
  </div>
</div>
